// extracted by mini-css-extract-plugin
export default {"Modal":"uMNJ_hRZ7yRD863ONMZw","Modal__Content":"uL8DbesO1OKzQC1q_zKx","Modal__Body":"qbbCbBj4qXZuKgrT_nzO","Button":"kIy_14l6_22C2Q8mkaQv","ImageBox":"YfmubuEzxizkRMiDnlM6"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"Modal\":\"uMNJ_hRZ7yRD863ONMZw\",\"Modal__Content\":\"uL8DbesO1OKzQC1q_zKx\",\"Modal__Body\":\"qbbCbBj4qXZuKgrT_nzO\",\"Button\":\"kIy_14l6_22C2Q8mkaQv\",\"ImageBox\":\"YfmubuEzxizkRMiDnlM6\"}";
        // 1771418008683
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  